import store from '../../redux/store'
import axios from 'axios'


export function patch(path,data,successCallback=()=>{},errorCallback=()=>{}){
    const url = store.getState().entity.server + path
    return new Promise((resolve,reject)=>{
        axios.patch(url,data)
        .then(response=>{
            successCallback()
            resolve(response.data)
        })
        .catch(err=>{
            console.error(err)
            reject(err)
            errorCallback()
        })
    })  
   
}


export function get(path,params={},successCallback=()=>{},errorCallback=()=>{}){
    const url = store.getState().entity.server + path
    return new Promise((resolve,reject)=>{
        axios.get(url,params)
        .then(response=>{
            successCallback()
            resolve(response.data)
        })
        .catch(err=>{
            console.error(err)
            reject(err)
            errorCallback()
        })
    })  
}